<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>Tinker to Evers to Chance</h1>
<h1 class="bk1">The Chicago Cubs and the Dawn of Modern America</h1>
<p class="bkau">David Rapp</p>
<p class="bkpub">The University of Chicago Press   Chicago &amp; London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-rapp-0004.vue?756c7b4f